import { useTranslation } from "react-i18next";
import { IconButton, SvgIcon, Tooltip } from "@mui/material";
import { useThemeMode } from "@context/shared/ThemeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSunBright } from "@fortawesome/pro-solid-svg-icons";

export const DarkModeButton = () => {
  const { mode, toggleMode } = useThemeMode();
  const { t } = useTranslation();

  return (
    <Tooltip
      title={t("common.darkMode", {
        mode: t(mode === "light" ? "common.dark" : "common.light"),
      })}
    >
      <IconButton data-testid="dark-mode-button" onClick={toggleMode}>
        <SvgIcon>
          <FontAwesomeIcon
            color="white"
            icon={mode === "light" ? faMoon : faSunBright}
          />
        </SvgIcon>
      </IconButton>
    </Tooltip>
  );
};
